/**
 * What won't come over and what to check after the paste — the review's notes, each with where
 * it sits, folded into two rows (27/10/2026) whose summary is the first note. Nothing is dropped
 * silently: whatever the copy loses is named here before Paste.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ListChecks, type LucideIcon, MinusCircle } from 'lucide-react';
import type { GroupCopyNote } from '@trafficpulse/shared';

import { ReviewFold } from './ReviewFold';

const NoteLine: FC<{ note: GroupCopyNote }> = ({ note }) => (
  <div className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5 px-5 py-1.5 text-xs">
    <span className="shrink-0 rounded bg-muted px-1.5 py-px text-[11px] font-medium text-muted-foreground">{note.where}</span>
    <span className="min-w-0 flex-1 basis-48">{note.text}</span>
  </div>
);

const Notes: FC<{ title: string; icon: LucideIcon; notes: GroupCopyNote[]; legend: string }> = ({ title, icon, notes, legend }) =>
  notes.length === 0 ? null : (
    <ReviewFold icon={icon} title={title} count={notes.length} summary={notes[0]!.text}>
      <p className="px-5 py-2 text-[11.5px] text-muted-foreground">{legend}</p>
      {notes.map((n, i) => <NoteLine key={`${n.where}-${i}`} note={n} />)}
    </ReviewFold>
  );

export const NotesBlock: FC<{ notes: GroupCopyNote[] }> = ({ notes }) => (
  <>
    <Notes title="Won’t come over" icon={MinusCircle} notes={notes.filter((n) => n.level === 'lost')} legend="These stay behind in the copied country — the paste goes ahead without them." />
    <Notes title="Check after pasting" icon={ListChecks} notes={notes.filter((n) => n.level === 'check')} legend="These come over, but may not fit this country as they are — give them a look once the paste is done." />
  </>
);
